<template>
  <TarjetaDatos titulo="Peritación" tipo="naranja">
    <Campo2L :valor="encargo.fechaActuacion | dateDDMMYYYY" etiqueta="Fecha" />
    <Campo2L :valor="encargo.estado" etiqueta="Estado" />
    <Campo2L :valor="encargo.taller" etiqueta="Taller" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    encargo: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
